import { t } from "@lingui/macro";
import * as v from "valibot";
import type { Permission } from "~/models/permission";

export const key = "artist.edit";

export const permissions: Array<Permission | RegExp> = ["Artist.Edit"];

export function permissionsContext(hashParams: URLSearchParams) {
  if (!hashParams.has("artistUid")) {
    return { allPermissions: true };
  }

  return {
    artistId: hashParams.get("artistUid"),
  };
}

export const Schema = () =>
  v.object({
    artistUid: v.pipe(
      v.string(t`The artist ID is required.`),
      v.minLength(1, t`The artist ID is required.`),
    ),
  });
